'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import InnerPageHeader from '@/components/InnerPageHeader';
import HomepageFooter from '@/components/HomepageFooter';
import EnquiryModal from '@/components/EnquiryModal';

export default function SearchProcess() {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    // Add close animation classes
    const overlay = document.querySelector('.animate-fade-in');
    const modal = document.querySelector('.animate-slide-up');
    
    if (overlay) {
      overlay.classList.remove('animate-fade-in');
      overlay.classList.add('animate-fade-out');
    }
    
    if (modal) {
      modal.classList.remove('animate-slide-up');
      modal.classList.add('animate-slide-down');
    }
    
    // Hide modal after animation
    setTimeout(() => {
      setShowModal(false);
    }, 300);
  };
  return (
    <div className="min-h-screen bg-[#F6EFED] page-transition">
      {/* Header Component */}
      <InnerPageHeader />

      {/* Hero Search Section */}
      <section className="bg-[#f6efed] py-[100px]">
        <div className="max-w-[1400px] mx-auto px-[20px] text-center">
          <h1 className="font-['Gotham_Rounded',sans-serif] text-[48px] font-bold text-[#2E2A3A] leading-[56px] mb-6">
            Find Verified Women-Only <br></br>Fitness Near You
          </h1>
          <p className="font-['Archivo',sans-serif] text-[18px] font-normal text-[#000000] leading-[36px] tracking-[3%] mb-10 max-w-3xl mx-auto">
           Discover safe, women-only gyms, studios activities customised for your comfort and privacy.
          </p>

          {/* Search Form */}
          <div className="flex max-w-5xl mx-auto items-stretch bg-white rounded-[10px] shadow-md overflow-hidden">
            {/* Location Input */}
            <div className="w-1/2 relative">
              <div className="absolute left-6 top-1/2 -translate-y-1/2">
                <svg className="w-5 h-5 text-[#a0969e]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                </svg>
              </div>
              <input
                type="text"
                placeholder="Enter postcode or area"
                className="w-full h-full pl-14 pr-6 py-5 bg-transparent border-none text-[#2b262e] text-[18px] font-light placeholder:text-[#a0969e] outline-none font-['Archivo',sans-serif]"
              />
            </div>

            {/* Vertical Divider */}
            <div className="w-px bg-[#e8e1e6]"></div>

            {/* Activity Dropdown */}
            <div className="w-1/2 relative">
              <select className="appearance-none px-8 py-[21px] pr-12 bg-transparent border-none text-[#2b262e] text-[18px] font-light outline-none cursor-pointer font-['Archivo',sans-serif] w-full h-full">
                <option>Select Activity</option>
                <option>Gym</option>
                <option>Yoga</option>
                <option>Pilates</option>
                <option>Boxing</option>
                <option>Swimming</option>
              </select>
              <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
                <svg className="w-4 h-4 text-[#a0969e]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>

            {/* Search Button */}
            <button className="m-[6px] py-[20px] px-[35px] bg-[#8A7296] hover:bg-[#7a647d] text-white transition-colors inline-flex items-center gap-2 font-['Archivo',sans-serif] text-[18px] font-medium rounded-[6px]">
              Search
              <svg className="w-[20px] h-[20px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </button>
          </div>
        </div>
      </section>

      {/* Search Results Section */}
      <main className="bg-[#f6efed] pb-[100px]">
        <div className="max-w-[1490px] mx-auto px-[20px]">
          <div className="grid lg:grid-cols-[400px_1fr] gap-8">
            
            {/* Left Sidebar - Filters */}
            <aside className="space-y-[30px]">
              {/* Filters Box */}
              <div className="bg-[#FBEFF9] rounded-[18px] border-[10px] border-white">
                <div className="p-[30px] pb-4">
                  <div className="flex items-center justify-between pb-4 border-b border-[#e8e1e6]">
                    <h3 className="font-['Gotham_Rounded',sans-serif] text-[24px] font-medium text-[#2E2A3A]">Filters</h3>
                    <button className="font-['Archivo',sans-serif] text-[12px] font-medium text-[#8A7296] border border-[#8A7296] px-[14px] py-[8px] rounded-[50px] hover:bg-[#8A7296] hover:text-white transition-colors">Reset Filter</button>
                  </div>
                </div>

                {/* Verification Filters */}
                <div className="px-[30px] pb-[30px] space-y-[25px]">
                  <label className="flex items-center gap-3 cursor-pointer">
                    <input type="checkbox" className="w-5 h-5 rounded-[4px] border-[#8A7296] text-[#8A7296] focus:ring-[#8A7296] accent-[#8A7296] checked:bg-white checked:border-[#8A7296]" defaultChecked />
                    <Image src="/Verified by FFF.svg" width={20} height={20} alt="Verified by FFF" />
                    <span className="font-['Archivo',sans-serif] text-[16px] font-normal text-[#00000080]">Verified by FFF</span>
                  </label>
                  <label className="flex items-center gap-3 cursor-pointer">
                    <input type="checkbox" className="w-5 h-5 rounded-[4px] border-[#8A7296] text-[#8A7296] focus:ring-[#8A7296] accent-[#8A7296] checked:bg-white checked:border-[#8A7296]" defaultChecked />
                    <Image src="/Women-Only Spaces.svg" width={20} height={20} alt="Women-Only Spaces" />
                    <span className="font-['Archivo',sans-serif] text-[16px] font-normal text-[#00000080]">Women-Only Spaces</span>
                  </label>
                  <label className="flex items-center gap-3 cursor-pointer">
                    <input type="checkbox" className="w-5 h-5 rounded-[4px] border-[#8A7296] text-[#8A7296] focus:ring-[#8A7296] accent-[#8A7296] checked:bg-white" />
                    <span className="text-[20px]">👩‍💼</span>
                    <span className="font-['Archivo',sans-serif] text-[16px] font-normal text-[#00000080]">Women-Led Businesses</span>
                  </label>
                </div>

                {/* Session Type */}
                <div className="px-[30px] pb-[30px] border-t border-[#e8e1e6] pt-6">
                  <h4 className="font-['Gotham_Rounded',sans-serif] text-[16px] font-bold text-[#2E2A3A] mb-4">Session Type</h4>
                  <div className="space-y-[25px]">
                    {['Strength Classes', 'Yoga', 'Pilates', 'Gym', 'Dance', 'Personal Training', 'Swimming'].map((type) => (
                      <label key={type} className="flex items-center gap-3 cursor-pointer">
                        <input type="checkbox" className="w-5 h-5 rounded-[4px] border-[#8A7296] text-[#8A7296] focus:ring-[#8A7296] accent-[#8A7296] checked:bg-white" />
                        <span className="font-['Archivo',sans-serif] text-[16px] font-normal text-[#00000080]">{type}</span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>

              {/* Business Partnerships Box */}
              <div className="bg-[#FBEFF9] rounded-[18px] border-[10px] border-white">
                <div className="p-[30px] pb-4">
                  <div className="flex items-center justify-between mb-4 pb-4 border-b border-[#e8e1e6]">
                    <h3 className="font-['Gotham_Rounded',sans-serif] text-[24px] font-medium text-[#2E2A3A]">Business Partnerships</h3>
                  </div>
                </div>
                <div className="px-[30px] pb-[30px]">
                <p className="font-['Archivo',sans-serif] text-[20px] font-medium text-[#2E2A3A] mb-4">Own a women-only fitness spaces?</p>
                <p className="font-['Archivo',sans-serif] text-[16px] text-[#6e6672] mb-6">Join Female Fitness Finder.</p>
                <button className="w-full px-6 py-4 bg-[#8A7296] hover:bg-[#7a647d] text-white rounded-[10px] transition-colors font-['Archivo',sans-serif] text-[18px] font-medium mb-4 flex items-center justify-center gap-2">
                  Apply to be listed on FFF
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </button>
                <Link href="/verification-standards" className="w-full px-6 py-4 bg-white text-[#8A7296] hover:bg-[#8A7296] hover:text-white rounded-[10px] transition-colors font-['Archivo',sans-serif] text-[18px] font-medium flex items-center justify-center gap-2 no-underline">
                  How Verification Works
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </Link>
                </div>
              </div>
            </aside>

            {/* Right Content - Results */}
            <div>
              <div className="space-y-8 bg-white rounded-[24px] p-[35px]">
                {/* Results Header */}
                <div>
                  <h2 className="font-['Gotham_Rounded',sans-serif] text-[32px] font-bold text-[#2E2A3A] mb-2">
                    Verified Women-Only Fitness Activities Near You
                  </h2>
                  <p className="font-['Archivo',sans-serif] text-[16px] text-[#6e6672]">
                    Showing <span className="font-bold text-[#2E2A3A]">2 spaces</span> near you
                  </p>
                </div>

                {/* Listing Cards */}
                <div className="space-y-6">
                {/* Card 1 */}
                <div className="bg-white rounded-[18px] p-[10px] border border-[#0000001A]">
                  <div className="grid md:grid-cols-[260px_1fr] gap-6">
                    <div className="relative h-[340px] rounded-[10px] overflow-hidden">
                      <Image src="/gym-card-1.jpg" alt="Empowered Gyms Bromley" fill className="object-cover" />
                    </div>
                    <div className="space-y-4">
                      <div className="flex items-start justify-between">
                        <div>
                          <h3 className="font-['Gotham_Rounded',sans-serif] text-[24px] font-bold text-[#2E2A3A] mb-2">
                            Empowered Gyms Bromley Online
                          </h3>
                          <div className="flex items-center gap-2 mb-2">
                            <div className="flex items-center gap-1">
                              {[...Array(5)].map((_, i) => (
                                <svg key={i} className="w-4 h-4 text-[#FFA500]" fill="currentColor" viewBox="0 0 24 24">
                                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                                </svg>
                              ))}
                            </div>
                            <span className="font-['Archivo',sans-serif] text-[14px] font-bold text-[#2E2A3A]">4.9</span>
                            <span className="font-['Archivo',sans-serif] text-[14px] text-[#6e6672]">(138 reviews)</span>
                          </div>
                        </div>
                        <span className="px-3 py-1 bg-[#ebe7ec] text-[#796080] rounded-[5px] font-['Archivo',sans-serif] text-[15px] font-medium flex items-center gap-1">
                          <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                          </svg>
                          Verified by FFF
                        </span>
                      </div>
                      <p className="font-['Archivo',sans-serif] text-[14px] text-[#2E2A3A] leading-[24px]">
                        A serene women-only yoga and mindfulness studio nestled in the heart of Islington. Founded by women, for women - every class... <span className="text-[#8A7296] font-medium cursor-pointer">Read More</span>
                      </p>
                      <div className="flex items-center gap-2 flex-wrap">
                        <span className="text-[#796080] rounded-[5px] font-['Archivo',sans-serif] text-[16px] font-medium">Strength</span>
                        <span className="w-[3px] h-[3px] bg-[#796080] rounded-full"></span>
                        <span className="text-[#796080] rounded-[5px] font-['Archivo',sans-serif] text-[16px] font-medium">Yoga</span>
                        <span className="w-[3px] h-[3px] bg-[#796080] rounded-full"></span>
                        <span className="text-[#796080] rounded-[5px] font-['Archivo',sans-serif] text-[16px] font-medium">Pilates</span>
                      </div>
                      <div className="flex items-center gap-3 flex-wrap">
                        <span className="px-3 py-1 bg-[#ebe7ec] text-[#2E2A3A] rounded-[5px] font-['Archivo',sans-serif] text-[15px] flex items-center gap-1">
                          <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                          </svg>
                          Women-Only
                        </span>
                        <span className="px-3 py-1 bg-[#ebe7ec] text-[#2E2A3A] rounded-[5px] font-['Archivo',sans-serif] text-[15px] flex items-center gap-1">
                          <span className="text-[15px]">👩‍💼</span>
                          Women-Led
                        </span>
                      </div>
                      <div className="flex items-center justify-between mt-[25px] bg-[#FBEFF9] p-[10px] rounded-[5px]">
                        <span className="px-3 py-1 text-black font-['Archivo',sans-serif] text-[16px] flex items-center gap-1">
                          <Image src="/Verified by FFF.svg" width={12} height={12} alt="Verified by FFF" />
                          Verified by Female Fitness Finder
                        </span>
                        <div className="flex items-center gap-3">
                          <button 
                            onClick={openModal}
                            className="px-[16px] py-[15px] bg-[#8A7296] hover:bg-[#7a647d] text-white rounded-[10px] transition-colors font-['Archivo',sans-serif] text-[16px] font-medium flex items-center gap-2"
                          >
                            Send Enquiry
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                          </button>
                          <Link href="/studio/empowered-gyms-bromley" className="px-[16px] py-[15px] bg-white text-[#8A7296] hover:bg-[#8A7296] hover:text-white rounded-[10px] transition-colors font-['Archivo',sans-serif] text-[16px] font-medium flex items-center gap-2 text-decoration-none">
                            View Details
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Card 2 */}
                <div className="bg-white rounded-[18px] p-[10px] border border-[#0000001A]">
                  <div className="grid md:grid-cols-[260px_1fr] gap-6">
                    <div className="relative h-[340px] rounded-[10px] overflow-hidden">
                      <Image src="/gym-card-2.jpg" alt="Empowered Gyms Bromley" fill className="object-cover" />
                    </div>
                    <div className="space-y-4">
                      <div className="flex items-start justify-between">
                        <div>
                          <h3 className="font-['Gotham_Rounded',sans-serif] text-[24px] font-bold text-[#2E2A3A] mb-2">
                            Empowered Gyms Bromley Online
                          </h3>
                          <div className="flex items-center gap-2 mb-2">
                            <div className="flex items-center gap-1">
                              {[...Array(5)].map((_, i) => (
                                <svg key={i} className="w-4 h-4 text-[#FFA500]" fill="currentColor" viewBox="0 0 24 24">
                                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                                </svg>
                              ))}
                            </div>
                            <span className="font-['Archivo',sans-serif] text-[14px] font-bold text-[#2E2A3A]">4.9</span>
                            <span className="font-['Archivo',sans-serif] text-[14px] text-[#6e6672]">(138 reviews)</span>
                          </div>
                        </div>
                        <span className="px-3 py-1 bg-[#ebe7ec] text-[#796080] rounded-[5px] font-['Archivo',sans-serif] text-[15px] font-medium flex items-center gap-1">
                          <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                          </svg>
                          Verified by FFF
                        </span>
                      </div>
                      <p className="font-['Archivo',sans-serif] text-[14px] text-[#2E2A3A] leading-[24px]">
                        A serene women-only yoga and mindfulness studio nestled in the heart of Islington. Founded by women, for women - every class... <span className="text-[#8A7296] font-medium cursor-pointer">Read More</span>
                      </p>
                      <div className="flex items-center gap-2 flex-wrap">
                        <span className="text-[#796080] rounded-[5px] font-['Archivo',sans-serif] text-[16px] font-medium">Strength</span>
                        <span className="w-[3px] h-[3px] bg-[#796080] rounded-full"></span>
                        <span className="text-[#796080] rounded-[5px] font-['Archivo',sans-serif] text-[16px] font-medium">Yoga</span>
                        <span className="w-[3px] h-[3px] bg-[#796080] rounded-full"></span>
                        <span className="text-[#796080] rounded-[5px] font-['Archivo',sans-serif] text-[16px] font-medium">Pilates</span>
                      </div>
                      <div className="flex items-center gap-3 flex-wrap">
                        <span className="px-3 py-1 bg-[#ebe7ec] text-[#2E2A3A] rounded-[5px] font-['Archivo',sans-serif] text-[15px] flex items-center gap-1">
                          <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                          </svg>
                          Women-Only
                        </span>
                        <span className="px-3 py-1 bg-[#ebe7ec] text-[#2E2A3A] rounded-[5px] font-['Archivo',sans-serif] text-[15px] flex items-center gap-1">
                          <span className="text-[15px]">👩‍💼</span>
                          Women-Led
                        </span>
                      </div>
                      <div className="flex items-center justify-between mt-[25px] bg-[#FBEFF9] p-[10px] rounded-[5px]">
                        <span className="px-3 py-1 text-black font-['Archivo',sans-serif] text-[16px] flex items-center gap-1">
                          <Image src="/Verified by FFF.svg" width={12} height={12} alt="Verified by FFF" />
                          Verified by Female Fitness Finder
                        </span>
                        <div className="flex items-center gap-3">
                          <button 
                            onClick={openModal}
                            className="px-[16px] py-[15px] bg-[#8A7296] hover:bg-[#7a647d] text-white rounded-[10px] transition-colors font-['Archivo',sans-serif] text-[16px] font-medium flex items-center gap-2"
                          >
                            Send Enquiry
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                          </button>
                          <Link href="/studio/empowered-gyms-bromley" className="px-[16px] py-[15px] bg-white text-[#8A7296] hover:bg-[#8A7296] hover:text-white rounded-[10px] transition-colors font-['Archivo',sans-serif] text-[16px] font-medium flex items-center gap-2 text-decoration-none">
                            View Details
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
                          {/* Why Choose Female Fitness Finder Section */}
            <div className="mt-8 pl-[35px] flex justify-between items-center gap-[40px] md:flex-row flex-col">
              <div className="fff-why-left">
                <h2 className="font-['Gotham_Rounded',sans-serif] text-[30px] font-bold text-[#2E2A3A] mb-6">
                  Why Choose Female Fitness Finder?
                </h2>

                <div className="fff-feature flex items-start gap-[10px] mb-[30px]">
                  <div className="fff-icon w-[50px] h-[50px] rounded-full bg-[#8A7296] text-white flex items-center justify-center flex-[0_0_50px]">
                    <Image src="/plane.svg" width={20} height={20} alt="Plane icon" />
                  </div>
                  <div>
                    <h3 className="font-['Gotham_Rounded',sans-serif] text-[18px] font-medium text-[#2E2A3A] mb-0">
                      Every space is women-only and women-led
                    </h3>
                    <p className="font-['Archivo',sans-serif] text-[16px] text-[#000000B3] leading-[24px]">
                      Connect with women searching for women-only gyms and studios.
                    </p>
                  </div>
                </div>

                <div className="fff-feature flex items-start gap-[10px] mb-[30px]">
                  <div className="fff-icon w-[50px] h-[50px] rounded-full bg-[#8A7296] text-white flex items-center justify-center flex-[0_0_50px]">
                    <Image src="/plane.svg" width={20} height={20} alt="Plane icon" />
                  </div>
                  <div>
                    <h3 className="font-['Gotham_Rounded',sans-serif] text-[18px] font-medium text-[#2E2A3A] mb-0">
                      Independently reviewed
                    </h3>
                    <p className="font-['Archivo',sans-serif] text-[16px] text-[#000000B3] leading-[24px]">
                      List your space where women's actively searching for female-only fitness.
                    </p>
                  </div>
                </div>

                <div className="fff-feature flex items-start gap-[10px]">
                  <div className="fff-icon w-[50px] h-[50px] rounded-full bg-[#8A7296] text-white flex items-center justify-center flex-[0_0_50px]">
                    <Image src="/plane.svg" width={20} height={20} alt="Plane icon" />
                  </div>
                  <div>
                    <h3 className="font-['Gotham_Rounded',sans-serif] text-[18px] font-medium text-[#2E2A3A] mb-0">
                      Designed for safety, privacy and comfort
                    </h3>
                    <p className="font-['Archivo',sans-serif] text-[16px] text-[#000000B3] leading-[24px]">
                      Studios with FFF badge standout as safe, Female only spaces.
                    </p>
                  </div>
                </div>
              </div>

              <div className="fff-card w-[224px] bg-[#FBEFF9] border-[10px] border-white rounded-[24px] p-[30px] box-border md:w-auto">
                <h3 className="font-['Gotham_Rounded',sans-serif] text-[24px] font-bold text-[#2E2A3A] mb-4">
                  Get Listed
                </h3>

                <div className="fff-card-line h-[1px] bg-[rgba(46,42,58,0.08)] m-[12px_-17px_14px]"></div>

                <p className="font-['Archivo',sans-serif] text-[16px] leading-[24px] text-[#000000B3] mb-4">
                  Reach women searching for female-<br />
                  only fitness finder and build a trusted<br />
                  community.
                </p>

                <button className="w-full px-6 py-4 bg-[#8A7296] hover:bg-[#7a647d] text-white rounded-[10px] transition-colors font-['Archivo',sans-serif] text-[16px] font-medium mb-4 flex items-center justify-center gap-2">
                  Join Female Fitness Finder
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </button>

                <button className="w-full px-6 py-4 bg-white text-[#8A7296] hover:bg-[#8A7296] hover:text-white rounded-[10px] transition-colors font-['Archivo',sans-serif] text-[16px] font-medium flex items-center justify-center gap-2">
                  More About Partnering Benefit
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </button>
              </div>
            </div>
            </div>
          </div>
        </div>
      </main>

      {/* Modal Popup */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 animate-fade-in" style={{ backgroundColor: 'rgba(0, 0, 0, 0.3)' }}>
          <div className="enquiry-modal bg-white rounded-[24px] max-w-[1085px] w-full mx-4 overflow-hidden animate-slide-up relative">
            <button 
              onClick={closeModal}
              className="absolute top-4 right-4 text-[#6e6672] hover:text-[#2E2A3A] transition-colors text-[24px] font-light z-10"
            >
              ×
            </button>
            <div className="flex flex-col md:flex-row">
              {/* Image Section */}
              <div className="enquiry-image w-[375px] relative h-[400px] md:h-auto">
                <Image 
                  src="/popup-image.png" 
                  alt="Fitness enquiry" 
                  fill
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Content Section */}
              <div className="enquiry-content p-[50px] flex-1">
                <h2 className="font-['Gotham_Rounded',sans-serif] text-[28px] font-bold text-[#2E2A3A] mb-2">
                  Send an Enquiry
                </h2>
                <p className="subtext font-['Archivo',sans-serif] text-[16px] text-[#6e6672] mb-4">
                  Contact this verified women-only, women-led fitness space directly.
                </p>

                <hr className="border-[#e5e5e5] mb-4" />

                <p className="note font-['Archivo',sans-serif] text-[14px] text-[#6e6672] mb-4">
                  Your message will be send directly to the provider, Female Fitness Finder
                  does not handle bookings.
                </p>

                <div className="verified flex items-center gap-2 mb-6">
                  <span className="shield w-5 h-5 bg-[#8A7296] text-white rounded-full flex items-center justify-center text-[12px]">✓</span>
                  <span className="font-['Archivo',sans-serif] text-[14px] text-[#2E2A3A]">Verified by Female Fitness Finder</span>
                </div>

                <form className="space-y-4">
                  <div className="row flex gap-4">
                    <input 
                      type="text" 
                      placeholder="First Name"
                      className="flex-1 px-4 py-3 border border-[#d7d7d7] rounded-[10px] font-['Archivo',sans-serif] text-[16px] focus:outline-none focus:border-[#8A7296] transition-colors"
                    />
                    <input 
                      type="text" 
                      placeholder="Last Name"
                      className="flex-1 px-4 py-3 border border-[#d7d7d7] rounded-[10px] font-['Archivo',sans-serif] text-[16px] focus:outline-none focus:border-[#8A7296] transition-colors"
                    />
                  </div>

                  <input 
                    type="email" 
                    placeholder="Your email address"
                    className="w-full px-4 py-3 border border-[#d7d7d7] rounded-[10px] font-['Archivo',sans-serif] text-[16px] focus:outline-none focus:border-[#8A7296] transition-colors"
                  />

                  <textarea 
                    placeholder="Your message..."
                    className="w-full px-4 py-3 border border-[#d7d7d7] rounded-[10px] font-['Archivo',sans-serif] text-[16px] focus:outline-none focus:border-[#8A7296] transition-colors resize-none"
                    rows={4}
                  />

                  <button 
                    type="submit"
                    className="submit-btn w-full px-6 py-3 bg-[#8A7296] text-white rounded-[50px] font-['Archivo',sans-serif] text-[16px] font-medium hover:bg-[#7a647d] transition-colors flex items-center justify-center gap-2"
                  >
                    Send Enquiry ↗
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      <HomepageFooter />
    </div>
  );
}
